import isEqual from 'lodash.isequal';
var getTrackIndex = function getTrackIndex(track, queue) {
  return queue.findIndex(function (queueTrack) {
    return isEqual(queueTrack, track);
  });
};
export default getTrackIndex;